import React from 'react';

import { SheetBody, SheetTitle } from '@/components/ui/sheet';

/**
 * Centered message content for loading, error, and other informational states
 * in trading-related sheets (investment requests, withdrawals, etc.).
 * Render it inside the drawer's own SheetContent so state changes keep the same sheet.
 */
export const DrawerMessage = ({ title, children }: { title: string; children: React.ReactNode }) => (
    <>
        <SheetTitle className="sr-only">{title}</SheetTitle>
        <SheetBody>
            <div className="flex flex-col gap-6 p-6 text-center">{children}</div>
        </SheetBody>
    </>
);
